import fetchJSON from '@api/api_helper';

const getUrl = (key, type = 'brandfolder') => {
  if (type === 'collection') {
    return `/api/v4/collections/${key}/share_manifests`;
  }
  return `/api/v4/brandfolders/${key}/share_manifests`;
};

export const post = (options, updateFetchControllers) => {
  const { assetKey, assetName, brandfolderKey, collectionKey, type = 'brandfolder' } = options;
  const appendedOptions = {
    method: 'POST',
    body: {
      data: {
        attributes: {
          asset_keys: [assetKey],
          availability_end: null,
          expires: false,
          internal: false,
          name: `Print Request: ${assetName}`,
          require_identification: false,
        },
      },
    },
  };

  const key = type === 'collection' ? collectionKey : brandfolderKey;
  return fetchJSON(getUrl(key, type), appendedOptions, updateFetchControllers);
};
